export { default as Head } from './head';
export { default as Layout } from './layout';
export { default as Loader } from './loader';
export { default as Nav } from './nav';
export { default as Menu } from './menu';
export { default as Side } from './side';
export { default as Social } from './social';
export { default as Email } from './email';
export { default as Footer } from './footer';
export { default as Hero } from './sections/hero';
export { default as About } from './sections/about';
export { default as News } from './sections/news';
export { default as Research } from './sections/research';
export { default as Jobs } from './sections/jobs';
export { default as Education } from './sections/education';
export { default as Awards } from './sections/awards';
export { default as Featured } from './sections/featured';
export { default as Projects } from './sections/projects';
export { default as Skills } from './sections/skills';
export { default as Contact } from './sections/contact';
